import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';

////////////////////////////////////////////////////////////////////

export default class FormSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    //
  }

  componentWillUnmount() {
    //
  }

  findForm(evt) {
    if (evt.target.childNodes[0].value === ""){
      evt.target.removeChild(evt.target.childNodes[0]);
    }
    // this.props.fulcrum.forms.find(evt.target.value, this.formFound.bind(this));
    var headers = new Headers({
      'Accept': "application/json",
      'Content-Type': "application/json",
      "X-ApiToken": sessionStorage.getItem("fulcrum_query_token")
    });
    fetch("https://api.fulcrumapp.com/api/v2/forms/"+evt.target.value+".json", {
      method: "GET",
      headers: headers
    }).then(function(res){
      return res.json();
    }).then(function(form){
      this.props.setTableData(form.form.elements, form.form.name+".csv");
    }.bind(this)).catch(function(err){
      console.log("error", err);
    });
  }

  resetSelect(){
    this.form_id.value = ""
  }

  formFound(error, form) {
    if (error){
      console.log('Error: ', error);
      return;
    }
    this.props.setTableData(form.form.elements, form.form.name+".csv");
  }

  render() {
    var options = this.props.forms.map(function(d){
      return <option value={ d.id } key={ d.id } >{ d.name }</option>
    });
    options.unshift(<option value="" key="default">-- Pick a Form --</option>);

    return (
      <form>
        <FormGroup controlId="formSelect">
          <FormControl componentClass="select" onChange={ this.findForm.bind(this) } inputRef={ node => this.form_id = node }>
            { options }
          </FormControl>
        </FormGroup>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/forms.js